import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UltraAllFeatures.module.scss';
import { ReactComponent as IconBroadcast } from '../../../assets/images/icons/icon_broadcast.svg';
import { ReactComponent as IconBell } from '../../../assets/images/icons/icon_bell.svg';
import { ReactComponent as IconVet } from '../../../assets/images/icons/icon_vet_black.svg';
import { ReactComponent as IconCar } from '../../../assets/images/icons/icon_car.svg';
import { ReactComponent as IconConnected } from '../../../assets/images/icons/icon_connected.svg';
// Placeholder icon until the final asset is provided:
import { ReactComponent as IconVibration } from '../../../assets/images/icons/icon_vibration.svg'; // Fi CallBack™

export default function UltraAllFeatures() {
  const { t } = useTranslation();

  const features = [
    { icon: <IconBroadcast />, text: t('ultra_gps_tracking') },
    { icon: <IconVibration />, text: t('ultra_callback_technology') },
    { icon: <IconBell />, text: t('ultra_escape_alerts') },
    { icon: <IconVet />, text: t('ultra_vet_records') },
    { icon: <IconCar />, text: t('ultra_walks_car_rides') },
    { icon: <IconConnected />, text: t('ultra_works_with_devices') },
  ];

  return (
    <div className={styles.allFeaturesSection}>
      <h2 className={styles.allFeaturesHeading}>{t('ultra_all_features')}</h2>
      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.featureItem}>
            <div className={styles.featureIcon}>{feature.icon}</div>
            <div className={styles.featureText}>{feature.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
